import type { ReplacedFile } from '../lib/replaced-files'
import { formatRelativeTime } from '../lib/time'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from './ui/alert-dialog'

interface ReplaceConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  configName: string
  files: ReplacedFile[]
  /** Suggest renaming, for files the person is still choosing. */
  canRename?: boolean
}

export function ReplaceConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  configName,
  files,
  canRename = false
}: ReplaceConfirmDialogProps) {
  const one = files.length === 1
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Replace rows from {one ? 'another file' : 'other files'}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            {configName} already has {one ? 'a file' : 'files'} with{' '}
            {one ? 'this name' : 'these names'}. Running deletes the rows{' '}
            {one ? 'that file' : 'those files'} wrote and writes the new rows in their place.
            {canRename ? ' Rename the files instead if the names are a coincidence.' : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="rounded-md border border-line bg-bg-sunk px-3 py-2 text-xs text-ink-2">
          <p className="font-medium text-ink">Files whose rows are replaced</p>
          <ul className="mt-1 list-disc space-y-1 pl-4">
            {files.map((file) => (
              <li key={file.fileName}>
                <span className="font-mono">{file.fileName}</span> · received{' '}
                {formatRelativeTime(file.receivedAt)}
              </li>
            ))}
          </ul>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel size="sm">Cancel</AlertDialogCancel>
          <AlertDialogAction size="sm" variant="destructive" onClick={onConfirm}>
            Replace rows
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
